import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-pick',
  templateUrl: './pick.component.html',
  styleUrls: ['./pick.component.scss']
})
export class PickComponent implements OnInit {

  panelTypes: any[] = [
    { Description: "EXPOSED", id: "EF", selected: false, ImageUrl: '/assets/images/ef.svg' },
    { Description: "CONCEALED", id: "CF", selected: false, ImageUrl: '/assets/images/cf.svg' },
  ];

  paintColors: any[] = [
    {
      "ColorCode": "BARE",
      "CoolColorCode": "",
      "ColorDescription": "ZINCAALUME Plus",
      "ImageUrl": "/images/PaintChips/BARE.gif",
      "Color": "#aab1b8"
    },
    {
      "ColorCode": "WWT",
      "CoolColorCode": "WWTC",
      "ColorDescription": "WINTER WHITE",
      "Color": "#e2e6e4"
    },
    {
      "ColorCode": "SWT",
      "CoolColorCode": "SWTC",
      "Color": "#c1c1b3",
      "ColorDescription": "SURF WHITE"
    },
    {
      "ColorCode": "LST",
      "CoolColorCode": "LSTC",
      "Color": "#d7cdb4",
      "ColorDescription": "LIGHT STONE"
    },
    {
      "ColorCode": "DBG",
      "CoolColorCode": "DBGC",
      "Color": "#9b8d6e",
      "ColorDescription": "DESERT BEIGE"
    },
    {
      "ColorCode": "CGR",
      "CoolColorCode": "CGRC",
      "Color": "#aaa399",
      "ColorDescription": "CASCADE GRAY"
    },
    {
      "ColorCode": "TAU",
      "CoolColorCode": "TAUC",
      "Color": "#93897b",
      "ColorDescription": "TAUPE"
    },
    {
      "ColorCode": "PST",
      "CoolColorCode": "PSTC",
      "Color": "#73605b",
      "ColorDescription": "PATINA STEEL"
    },
    {
      "ColorCode": "CHB",
      "CoolColorCode": "CHBC",
      "Color": "#4d3622",
      "ColorDescription": "CHESTNUT BROWN"
    },
    {
      "ColorCode": "CLB",
      "CoolColorCode": "CLBC",
      "Color": "#2f241a",
      "ColorDescription": "CLASSIC BROWN"
    },
    {
      "ColorCode": "MBK",
      "CoolColorCode": "MBKC",
      "Color": "#000000",
      "ColorDescription": "MATTE BLACK"
    },
    {
      "ColorCode": "CAN",
      "CoolColorCode": "CANC",
      "Color": "#783e35",
      "ColorDescription": "CANYON RED"
    },
    {
      "ColorCode": "RRD",
      "CoolColorCode": "RRDC",
      "Color": "#782013",
      "ColorDescription": "RUSTIC RED"
    },
    {
      "ColorCode": "OTG",
      "CoolColorCode": "OTGC",
      "Color": "#717c7b",
      "ColorDescription": "OLD TOWN GRAY"
    },
    {
      "ColorCode": "OZG",
      "CoolColorCode": "OZGC",
      "Color": "#666662",
      "ColorDescription": "OLD ZINC GRAY"
    },
    {
      "ColorCode": "WCP",
      "CoolColorCode": "WCPC",
      "Color": "#423e22",
      "ColorDescription": "WEATHERED COPPER"
    },
    {
      "ColorCode": "SLG",
      "CoolColorCode": "SLGC",
      "Color": "#444c4d",
      "ColorDescription": "SLATE GRAY"
    },
    {
      "ColorCode": "TBL",
      "CoolColorCode": "TBLC",
      "Color": "#235272",
      "ColorDescription": "TAHOE BLUE"
    },
    {
      "ColorCode": "EVE",
      "CoolColorCode": "EVEC",
      "Color": "#3f6f52",
      "ColorDescription": "EVERGLADE"
    },
    {
      "ColorCode": "DGN",
      "CoolColorCode": "DGNC",
      "Color": "#005a3d",
      "ColorDescription": "DENALI GREEN"
    },
    {
      "ColorCode": "FGN",
      "CoolColorCode": "FGNC",
      "Color": "#0f3c2b",
      "ColorDescription": "FOREST GREEN"
    },
    {
      "ColorCode": "PEN",
      "CoolColorCode": "PENC",
      "Color": "#9f6533",
      "ColorDescription": "COPPER PENNY"
    },
    {
      "ColorCode": "NRS",
      "CoolColorCode": "NRSP",
      "Color": "#452a1a",
      "ColorDescription": "NATURAL RUST",
      "ImageUrl": "/images/PaintChips/NRSP.gif"
    }
  ]

  selectedFastener = "";
  selectedColor = "";

  constructor(public d: DataService) {


    //var goodColors = this.deduplicateAndSortByColor(this.paintColors);
    //this.paintColors = goodColors;
    //console.log(JSON.stringify(goodColors, null, 4));
  }

  ngOnInit() {

  }

  selectFastner(panel: any) {
    this.selectedFastener = this.selectedFastener == panel.id ? "" : panel.id;
  }

  selectColor(paint: any) {
    this.selectedColor = this.selectedColor == paint.ColorCode ? "" : paint.ColorCode;
  }

  deduplicateAndSortByColor = (arr: any[]): any[] => {
    return Array.from(new Set(arr.map(obj => JSON.stringify(obj))))
      .map(str => JSON.parse(str))
      .sort((a: any, b: any) => {
        //return a.ColorDescription.localeCompare(b.ColorDescription);
        console.log(a);
        var aDesc = a.ColorDescription.replace("Cool ", "");
        var bDesc = b.ColorDescription.replace("Cool ", "");;
        return aDesc.localeCompare(bDesc);
      });

  };

}

